import { Loader2 } from 'lucide-react';
import { cn } from '../lib/cn';

/** The only continuous motion allowed, and only while work is running (CLAUDE.md §6.7). */
export function Spinner({ label, className }: { label: string; className?: string }) {
  return (
    <Loader2
      role="img"
      aria-label={label}
      className={cn('size-4 animate-spin text-text-3', className)}
    />
  );
}
